
export async function getElementFromSelector (selector) {

    function waitForSelector (resolve) {
        const maxDuration = 10000;
        let count = 0;
        const tik = 500;

        function checkSelector () {
            const el =  document.body.querySelector(selector);
            if (el || count >= maxDuration) {
                 resolve(el);
            } else {
                setTimeout(checkSelector, tik);
            }
            count += tik;
        }
        setTimeout(checkSelector, tik);
    }
    return new Promise(waitForSelector);
}

export function rgbaToHex (rgba) {
    if (rgba === 'transparent') {
        return '#00000000'; // Or any default color you prefer
    }
    const match = rgba.match(/^rgba?\((\d+), (\d+), (\d+),? (\d+)?\)$/);
    if (match) {
      const [r, g, b, a] = match.slice(1).map(Number);
      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}${a.toString(16).padStart(2, '0')}`;
    }
    return rgba;
}

export function supportsDvh() {
    return typeof CSS !== 'undefined' && CSS.supports('height: 100dvh');
}

/*
 * this helper will help us detect if specific css is available and make adjustments to the styles
 */
export function detectClassesInCSS (cssUrl, targetClasses) {
    return new Promise((resolve) => {
      fetch(cssUrl)
        .then((response) => response.text())
        .then((cssText) => {
            const classRegex = /\.([a-zA-Z0-9_-]+)\s*\{([^}]*)\}/g; // Regex to capture class and content
            let match;
            const classData = {};
    
            while ((match = classRegex.exec(cssText)) !== null) {
              const className = match[1];
              const classContent = match[2].trim(); // Trim whitespace
              classData[className] = classContent;
            }
    
            const foundClasses = targetClasses.reduce((acc, targetClass) => {
              if (classData[targetClass]) {
                acc[targetClass] = classData[targetClass];
              }
              return acc;
            }, {});
    
            resolve(foundClasses);
        })
        .catch((error) => {
            console.log('detectClassesInCSS(): error ', error);
            resolve({});
        });
    });
}

export const ClientsCSSTargets = [
    'ecal-primary-button',
    'Button__button___2a549',
];